import styled from '@emotion/styled'
import { css } from '@emotion/react'

const baseStyles = ({ theme }) => css`
  label: title;

  width: 100%;

  display: inline-grid;
  grid-template-columns: 50% 1fr;
  grid-template-areas:
    "type button"
    "quantity shipping";
  row-gap: ${theme.spacings.bit};

  background-color: ${theme.colors.white};
  padding: ${theme.spacings.kilo};

  ${theme.media.mega} {
    grid-template-columns: 30% 100px 1fr 1fr 20px;
    grid-template-areas: "type quantity shipping . button";
  }
`

const typeStyles = ({ theme }) => css`
  label: title__type;

  grid-area: type;
  justify-self: start;

  ${theme.media.mega} {
    align-self: center;
  }
`

const quantityStyles = () => css`
  label: title__quantity;

  grid-area: quantity;
  justify-self: start;

  text-align: center;
`

const shippingStyles = ({ theme }) => css`
  label: title__shipping;

  grid-area: shipping;
  justify-self: end;

  ${theme.media.mega} {
    justify-self: start;
  }
`

const buttonStyles = ({ theme }) => css`
  label: title__button;

  grid-area: button;
  justify-self: end;

  ${theme.media.mega} {
    align-self: center;
  }
`

export const Wrapper = styled('div')(baseStyles)
export const Type = styled('div')(typeStyles)
export const Quantity = styled('div')(quantityStyles)
export const Shipping = styled('div')(shippingStyles)
export const Button = styled('div')(buttonStyles)
